<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ dialogtitle }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            @keyup="saveIt"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <z-input
            v-model="url"
            name="url"
            label="URL"
            validate="required"
            @keyup="saveIt"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-6">
          <z-message
            v-model="notice"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'helpvideo-dialog',
  components: {
    ZDialog,
    ZInput,
    ZMessage,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      notice: '',
      isSave: false,
      validErrors: [],
      isVO2: false,
    }
  },
  mounted() {},
  computed: {
    ...mapGetters('configuration', ['setting']),
    isVisible() {
      return this.show !== null
    },
    dialogtitle() {
      let _title = 'Edit Help Video'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Help Video'
        } else if (this.setting) {
          _title = `Edit Help Video`
        }
      }
      return _title
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    id() {
      let _id = ''
      if (this.setting) {
        _id = this.setting.id
      }
      return _id
    },
    name: {
      get() {
        let _data = ''
        if (this.setting) {
          _data = this.setting.Name
        }
        return _data
      },
      set(value) {
        this.setSettingData({
          name: 'Name',
          value: value,
        })
      },
    },
    url: {
      get() {
        let _data = ''
        if (this.setting) {
          _data = this.setting.TextValue
        }
        return _data
      },
      set(value) {
        this.setSettingData({
          name: 'TextValue',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('configuration', ['setSettingData', 'saveSetting']),
    editorChanged(e) {
      console.log('Editor Changed', e)
      this.isSave = true
    },
    saveIt() {
      this.isSave = true
      this.$emit('saveIt')
    },
    showMessage(msg) {
      this.notice = msg
    },
    validate() {
      this.notice = ''
      let valid = true
      this.validErrors = []
      if (this.setting.Name.trim() === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.setting.TextValue.trim() === '') {
        valid = false
        this.validErrors.push('url')
      }
      return valid
    },
    async performSave(closeIt) {
      this.notice = ''
      let success = false
      let valid = this.validate()
      if (valid) {
        // Save Here
        console.log('Save Help Video', this.setting)
        let results = await this.saveSetting(this.setting)
        console.log('Saved Help Video Results', results)
        if (results.error) {
          this.notice = results.error
        } else {
          success = true
          this.isSave = false
          this.$emit('saved')
        }
      }
      return success
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-editor {
  height: 240px;
  margin-bottom: 45px;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-check {
  position: relative;
  top: 30px;
  left: 15px;
  label {
    margin-left: 5px;
  }
}
</style>
